import isEmpty from 'lodash/isEmpty';
import {SortDirection} from 'utils/DBUtils';
import * as ResourceApi from 'api/resources';
import {sortOptionsFactory, filterOptionsFactory} from './factories';

// configuration for defining viewOptions initialState filters and sorts by resource.
//
// if you want a specific resource's filter/sort options to get persisted in localStorage,
// you've come to the right place.
const resourceConfigs = {
  [ResourceApi.Types.Image]: {
    sortOptions: {
      possibleFields: [
        'name',
        '_created',
        'imageType'
      ],
      defaultSort: {
        field: '_created',
        direction: SortDirection.Descending
      }
    },
    filterOptions: {}
  },

  [ResourceApi.Types.Challenge]: {
    sortOptions: {
      possibleFields: [
        'lastEdit',
        'publishStatus',
        'permalink',
        'startDate',
        'sponsoredType'
      ],
      defaultSort: {
        field: 'lastEdit',
        direction: SortDirection.Descending
      }
    },
    filterOptions: {}
  },

  [ResourceApi.Types.Prize]: {
    sortOptions: {
      possibleFields: [
        'title',
        'publishStatus',
        'breakId',
        'numberOfEntries',
        'startTime',
        'endTime',
        '_created'
      ],
      defaultSort: {
        field: 'startTime',
        direction: SortDirection.Descending
      }
    },
    filterOptions: {
      namedFilters: ['prize_site_dailybreak']
    }
  },

  [ResourceApi.Types.PrizeEntry]: {
    sortOptions: {
      possibleFields: [
        'lastName',
        'prizeName',
        'status',
        'dateContacted',
        'renotifiedDate',
        'forfeitDate',
        'winner',
        '_created'
      ],
      defaultSort: {
        field: 'dateContacted',
        direction: SortDirection.Descending
      }
    },
    filterOptions: {
      filters: [
        {
          field: 'lang',
          value: 'en-US'
        }
      ]
    }
  },

  [ResourceApi.Types.StoreCatalog]: {
    sortOptions: {
      possibleFields: [
        'allocated',
        'cost',
        'inStock',
        'points',
        'price',
        'purchased',
        'title'
      ],
      defaultSort: {
        field: 'allocated',
        direction: SortDirection.Descending
      }
    },
    filterOptions: {}
  },

  [ResourceApi.Types.User]: {
    sortOptions: {
      possibleFields: [
        'created_on',
        'email',
        'id',
        'username',
        'firstName',
        'lastName',
        'siteId',
        'roles'
      ],
      defaultSort: {}
    },
    filterOptions: {}
  },

  [ResourceApi.Types.SurveyUserAnswer]: {
    sortOptions: {
      possibleFields: [],
      defaultSort: {}
    },
    filterOptions: {}
  },

  [ResourceApi.Types.Campaign]: {
    sortOptions: {
      possibleFields: [],
      defaultSort: {}
    },
    filterOptions: {}
  },

  [ResourceApi.Types.UGCSubmission]: {
    sortOptions: {
      possibleFields: [],
      defaultSort: {}
    },
    filterOptions: {}
  }
};

// transforms the above config object into the `resources` property of this reducer's initialState.
const createResourceViewOptions = configs => Object.keys(configs).reduce((resources, resourceType) => {
  const config = configs[resourceType];

  const {possibleFields, defaultSort} = config.sortOptions;
  let sortOptions = sortOptionsFactory(...possibleFields);
  if (!isEmpty(defaultSort)) {
    sortOptions.sorts[defaultSort.field] = defaultSort.direction;
  }

  const filterOptions = filterOptionsFactory(config.filterOptions);

  resources[resourceType] = {
    sortOptions,
    filterOptions
  };

  return resources;
}, {});

export default {
  resources: createResourceViewOptions(resourceConfigs)
};



// WEBPACK FOOTER //
// ./public/viewOptions/initialState.js